<template>
  <div>
    <CRow>
      <CCol md sm="3" class="mb-sm-2 mb-0">
        <CLink class="widget-link" to="/podcasts/podcasts"
          ><CWidgetProgressIcon :header="podcasts" :value="100" text="Podcast shows" inverse color="github">
            <CIcon name="cil-rss" height="36" /> </CWidgetProgressIcon
        ></CLink>
      </CCol>
      <CCol md sm="3" class="mb-sm-2 mb-0">
        <CLink class="widget-link" to="/podcasts/episodes"
          ><CWidgetProgressIcon :header="episodes" :value="100" text="Episodes" inverse color="pinterest">
            <CIcon name="cil-microphone" height="36" /> </CWidgetProgressIcon
        ></CLink>
      </CCol>
      <CCol md sm="3" class="mb-sm-2 mb-0">
        <CWidgetProgressIcon :header="users" :value="100" text="Users" inverse color="xing"
          ><CIcon name="cil-people" height="36"
        /></CWidgetProgressIcon>
      </CCol>
      <CCol md sm="3" class="mb-sm-2 mb-0">
        <CWidgetProgressIcon
          :header="episodes_started"
          :value="100"
          text="Episodes started"
          inverse
          color="stack-overflow"
        >
          <CIcon name="cil-headphones" height="36" />
        </CWidgetProgressIcon>
      </CCol>
    </CRow>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol sm="6">
            <WidgetTopTen :items="most_episodes_started" />
          </CCol>
          <CCol sm="6">
            <WidgetLineChart
              title="Daily episode starts"
              subtitle="Per day over the last 30 days"
              :labels="daily_episodes_started.labels"
              :datasets="daily_episodes_started.datasets"
            />
            <WidgetLineChart
              title="New users per day"
              subtitle="Per day over the last 30 days"
              :labels="new_users.labels"
              :datasets="new_users.datasets"
            />
            <WidgetLineChart
              title="New users per hour"
              subtitle="Per hour over last 24 hours"
              :labels="latest_new_users.labels"
              :datasets="latest_new_users.datasets"
            />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
        <CRow>
          <CCol md sm="6">
            <h4 class="mb-4 mt-2">Newly added podcasts</h4>
            <CListGroup>
              <CListGroupItem
                v-for="(item, index) in latest_podcasts"
                :key="index"
                @click="openItem(item.id, 'podcast')"
                style="cursor:pointer"
              >
                <img :src="item.image_url || pixel" class="list_image" />
                <strong>{{ item.title }}</strong
                ><br />
                {{ niceDate(item.date_added) }}
              </CListGroupItem>
            </CListGroup>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <p class="text-muted">{{ todaysDate }}</p>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import moment from 'moment'
import { PIXEL } from '../constants'
import WidgetTopTen from '../components/WidgetTopTen'
import WidgetLineChart from '../components/WidgetLineChart'

export default {
  name: 'Dashboard',
  components: {
    WidgetLineChart,
    WidgetTopTen,
  },
  data() {
    return {
      latest_podcasts: [],
      podcasts: '0',
      episodes: '0',
      users: '0',
      episodes_started: '0',
      new_users: {},
      latest_new_users: {},
      pixel: PIXEL,
      most_episodes_started: [],
      daily_episodes_started: [],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    todaysDate() {
      return moment().format('dddd, MMMM Do YYYY')
    },
  },
  methods: {
    getData() {
      this.$api.get('dashboard').then(response => {
        this.parseData(response.data)
      })
    },

    parseData(data) {
      const {
        notice,
        podcasts,
        episodes,
        screens,
        blocks,
        links,
        users,
        episodes_started,
        latest_podcasts,
        new_users,
        latest_new_users,
        most_episodes_started,
        daily_episodes_started,
      } = data

      this.notice = notice
      this.podcasts = '' + podcasts
      this.episodes = '' + episodes
      this.screens = '' + screens
      this.blocks = '' + blocks
      this.links = '' + links
      this.users = '' + users
      this.episodes_started = '' + episodes_started
      this.latest_podcasts = latest_podcasts
      this.new_users = new_users
      this.latest_new_users = latest_new_users
      this.most_episodes_started = most_episodes_started
      this.daily_episodes_started = daily_episodes_started
    },

    openItem(id, kind) {
      if (kind === 'podcast') {
        this.$router.push({ path: `/podcasts/podcasts/${id}` })
      } else {
        this.$router.push({ path: `/podcasts/episodes/${id}` })
      }
    },

    niceDate(dt) {
      return moment(dt).calendar()
    },
  },
}
</script>

<style>
.widget-link:hover {
  text-decoration: none;
}

.widget-link .text-value-lg {
  color: #1a1a1a;
}

.jumbotron {
  padding: 1.5em;
}

.list_image {
  width: 36px;
  height: 36px;
  margin: 4px 12px 0 0;
  background-color: white;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" class="c-sidebar-nav-icon"><path d="M5.192 5.192l-1.064-1.064c-0.005 0.004-0.009 0.009-0.014 0.013l-0 0c-2.023 2.023-3.275 4.818-3.275 7.905 0 3.071 1.238 5.852 3.243 7.873l-0.001-0.001 1.064-1.064c-1.734-1.746-2.805-4.152-2.805-6.808 0-2.679 1.090-5.104 2.852-6.854l0-0z"></path><path d="M19.925 4.141c-0.019-0.019-0.038-0.037-0.057-0.056l-1.064 1.064c1.788 1.755 2.895 4.197 2.895 6.897 0 2.666-1.080 5.080-2.825 6.828l0-0 1.064 1.064c2.015-2.022 3.261-4.811 3.261-7.892 0-3.087-1.251-5.882-3.274-7.905v0z"></path><path d="M7.196 7.196c-1.249 1.238-2.022 2.955-2.022 4.852 0 1.874 0.754 3.571 1.975 4.805l-0.001-0.001 1.060-1.060c-0.948-0.962-1.534-2.284-1.534-3.743 0-1.482 0.605-2.823 1.58-3.79l0-0z"></path><path d="M15.739 8.214c1.001 0.971 1.623 2.329 1.623 3.832 0 1.468-0.593 2.798-1.552 3.762l0-0 1.060 1.060c1.232-1.236 1.994-2.94 1.994-4.823 0-1.918-0.79-3.651-2.063-4.892l-0.001-0.001z"></path><path d="M13.817 10.136c-0.468-0.44-1.1-0.71-1.794-0.71-1.448 0-2.622 1.174-2.622 2.622s1.174 2.622 2.622 2.622c1.448 0 2.622-1.174 2.622-2.622 0-0 0-0 0-0v0c0-0.001 0-0.002 0-0.002 0-0.752-0.318-1.43-0.826-1.907l-0.001-0.001zM12.020 13.172c-0.621 0-1.125-0.504-1.125-1.125s0.504-1.125 1.125-1.125c0.621 0 1.125 0.504 1.125 1.125v0c0 0.621-0.504 1.125-1.125 1.125v0z"></path></svg>');
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  float: left;
}
</style>
